import React, { useState, useEffect, useRef } from 'react';
import {
    Clock,
    Shield,
    Zap, CheckCircle, ArrowRight, BarChart3, Upload, FileText,
    Building, CreditCard, TrendingUp, ArrowLeftRight, Layers, Workflow,
    Star, Play, Settings, Send, PieChart, RotateCcw, Cpu, Search, BarChart, SlidersHorizontal, FileBarChart,
    PlugZap
} from 'lucide-react';


import Footer from './footer';
import Header from './header';





export default function Switch() {
    const [animatedStats, setAnimatedStats] = useState({
        processingTime: 0,
        successRate: 0,
        dailyPayouts: 0,
        merchants: 0
    });

    const [isVideoPlaying, setIsVideoPlaying] = useState(false);
    const [isMuted, setIsMuted] = useState(true);
    const [animationStep, setAnimationStep] = useState(0);
    const [scrollY, setScrollY] = useState(0);
    const [isVisible, setIsVisible] = useState({});
    const [activeFeature, setActiveFeature] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [imageLoaded, setImageLoaded] = useState(false);
    const [currentTitle, setCurrentTitle] = useState(0);
    const videoRef = useRef(null);
    const sectionRefs = useRef([]);

    const [currentTitleIndex, setCurrentTitleIndex] = useState(0);

    // Scroll effect
    useEffect(() => {
        const handleScroll = () => setScrollY(window.scrollY);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Intersection Observer for animations
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsVisible(prev => ({
                            ...prev,
                            [entry.target.id]: true
                        }));
                    }
                });
            },
            { threshold: 0.1 }
        );

        sectionRefs.current.forEach((ref) => {
            if (ref) observer.observe(ref);
        });

        return () => observer.disconnect();
    }, []);

    // Animated stats
    useEffect(() => {
        const duration = 2000;
        const steps = 60;
        const interval = duration / steps;

        let currentStep = 0;
        const timer = setInterval(() => {
            currentStep++;
            const progress = currentStep / steps;
            const easeOut = 1 - Math.pow(1 - progress, 4);

            setAnimatedStats({
                processingTime: Math.round(15 * easeOut),
                successRate: Number((99.8 * easeOut).toFixed(1)),
                dailyPayouts: Math.round(50000 * easeOut),
                merchants: Math.round(25000 * easeOut)
            });

            if (currentStep >= steps) {
                clearInterval(timer);
            }
        }, interval);

        return () => clearInterval(timer);
    }, []);



    useEffect(() => {
        setIsVisible(true);
        const interval = setInterval(() => {
            setCurrentTitle((prev) => (prev + 1) % titles.length);
        }, 3000);

        return () => clearInterval(interval);
    }, []);








    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsVisible(prev => ({ ...prev, [entry.target.id]: true }));
                    }
                });
            },
            { threshold: 0.12 }
        );
        sectionRefs.current.forEach((ref) => ref && observer.observe(ref));
        return () => observer.disconnect();
    }, []);
    const reveal = (id, base = "") =>
        `${base} transition-all duration-700 ease-out will-change-transform will-change-opacity ${isVisible[id] ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-4 scale-[0.98]'
        } motion-reduce:transition-none motion-reduce:translate-y-0 motion-reduce:opacity-100`;

    const features = [
        {
            icon: <SlidersHorizontal className="w-7 h-7" />,
            title: "Smart Routing & Optimization",
            desc: "Multi-bank routing with AI-powered prioritization for maximum transaction success.",
            color: "blue"
        },
        {
            icon: <FileBarChart className="w-7 h-7" />,
            title: "MIS & Reporting",
            desc: "Real-time dashboards, exportable reports, and audit-ready logs for complete visibility.",
            color: "indigo"
        },
        {
            icon: <PlugZap className="w-7 h-7" />,
            title: "Integration Ready",
            desc: "Connect effortlessly with NPCI UPI switch, CBS, PSPs, and merchant platforms via APIs and SDKs.",
            color: "purple"
        }
    ];

    const payoutCapabilities = [
        {
            id: 1,
            title: "Instant Transfers",
            // description: "24x7 instant disbursements including holidays via IMPS, UPI, NEFT for immediate fund transfers to any bank account.",
            description: "24x7 including holidays via IMPS, UPI, NEFT",
            icon: <Send className="w-8 h-8 text-white" />,
            bgColor: "from-blue-500 to-blue-600",
            iconBg: "bg-blue-500"
        },
        // {
        //     id: 2,
        //     title: "24x7 Availability",
        //     description: "Round-the-clock payment processing with no downtime, ensuring your disbursements are processed even on holidays.",
        //     icon: <Clock className="w-8 h-8 text-white" />,
        //     bgColor: "from-green-500 to-green-600",
        //     iconBg: "bg-green-500"
        // },
        {
            id: 2,
            title: "Bulk Upload & APIs",
            // description: "Automate thousands of payments in a single click with bulk upload functionality and robust API integration capabilities.",
            description: "Automate thousands of payments in a single click.",
            icon: <Upload className="w-8 h-8 text-white" />,
            bgColor: "from-purple-500 to-purple-600",
            iconBg: "bg-purple-500"
        },
        {
            id: 3,
            title: "Maker-Checker Workflows",
            // description: "Dual-level approval system with maker-checker workflows ensuring compliance, control, and authorization for all disbursements.",
            description: "Dual-level approvals for compliance & control.",
            icon: <CheckCircle className="w-8 h-8 text-white" />,
            bgColor: "from-teal-500 to-teal-600",
            iconBg: "bg-teal-500"
        },
        {
            id: 4,
            title: "Automated Reconciliation",
            // description: "Real-time matching of disbursements with bank entries for accurate financial tracking and automated reconciliation processes.",
            description: "Match disbursements with bank entries in real time.",
            icon: <BarChart3 className="w-8 h-8 text-white" />,
            bgColor: "from-amber-500 to-amber-600",
            iconBg: "bg-amber-500"
        },
        {
            id: 5,
            title: "Detailed Reporting",
            // description: "Comprehensive tracking of each disbursement with real-time status updates and detailed transaction reporting.",
            description: "Track each disbursement with status updates.",
            icon: <FileText className="w-8 h-8 text-white" />,
            bgColor: "from-orange-500 to-orange-600",
            iconBg: "bg-orange-500"
        }
    ];

    const payoutTitles = [
        "PAY-OUT (DISBURSEMENTS)",
        // "INSTANT TRANSFERS",
        // "BULK PAYMENTS",
        // "SMART DISBURSEMENTS"
    ];

    const payoutDescriptions = [
        "Make instant, secure, and large-scale disbursements to vendors, partners, employees and customers.",
        "Experience lightning-fast fund transfers with 24x7 availability and multi-channel payment options for seamless business operations.",
        "Process thousands of payments simultaneously with automated bulk upload capabilities and intelligent workflow management.",
        "Optimize your disbursement operations with automated reconciliation, maker-checker approvals, and real-time tracking systems."
    ];

    useEffect(() => {
        setIsVisible(true);

        const titleInterval = setInterval(() => {
            setCurrentTitleIndex((prev) => (prev + 1) % payoutTitles.length);
        }, 4000);

        return () => clearInterval(titleInterval);
    }, []);


    const titles = [
        "Core Features of UPI Switch",
        // "SEAMLESS PAYMENTS",
        // "SECURE TRANSACTIONS",
        // "SMART COLLECTIONS"
    ];

    const descriptions = [
        // "Accept payments from your customers seamlessly through multiple channels.",
        // "Experience the future of payment processing with advanced AI-driven routing and omnichannel acceptance capabilities.",
        // "Protect your business with enterprise-grade security, fraud detection, and real-time monitoring systems.",
        // "Optimize your revenue collection with intelligent routing, automated reconciliation, and instant settlement solutions."
    ];



    const capabilities = [
        {
            id: 1,
            title: "Omnichannel Acceptance",
            // description: "Accept payments seamlessly through UPI, Cards, Net Banking, Wallets, and EMI options for maximum customer reach.",
            description: "UPI, Cards, Net Banking, Wallets, EMI",
            icon: <CreditCard className="w-8 h-8 text-white" />,
            bgColor: "from-purple-500 to-purple-600",
            iconBg: "bg-purple-500"
        },
        {
            id: 2,
            title: "Frictionless Checkout",
            // description: "Optimized user experience with streamlined checkout flows designed for higher conversion rates.",
            description: "Optimized user experience for higher conversions.",
            icon: <Zap className="w-8 h-8 text-white" />,
            bgColor: "from-blue-500 to-blue-600",
            iconBg: "bg-blue-500"
        },
        {
            id: 3,
            title: "Smart Routing",
            // description: "AI-driven payment routing intelligence that automatically selects optimal paths for higher success rates.",
            description: "AI-driven routing for higher success rates.",
            icon: <Settings className="w-8 h-8 text-white" />,
            bgColor: "from-teal-500 to-teal-600",
            iconBg: "bg-teal-500"
        },
        {
            id: 4,
            title: "Fraud & Risk Management",
            // description: "Advanced AI-based monitoring with velocity checks and real-time fraud detection to protect your business.",
            description: "AI-based monitoring, velocity checks & real-time fraud detection.",
            icon: <Shield className="w-8 h-8 text-white" />,
            bgColor: "from-green-500 to-green-600",
            iconBg: "bg-green-500"
        },
        {
            id: 5,
            title: "Settlement & Reconciliation",
            // description: "Automated fund settlement to merchant accounts with AI-powered reconciliation for accurate financial tracking.",
            description: "Automated fund settlement to merchant accounts with AI-powered reconciliation.",
            icon: <PieChart className="w-8 h-8 text-white" />,
            bgColor: "from-amber-500 to-amber-600",
            iconBg: "bg-amber-500"
        },
        {
            id: 6,
            title: "Refund Management",
            // description: "Process partial and full refunds instantly with complete audit trails for transparent transaction management.",
            description: "Process partial/full refunds instantly with complete audit trails.",
            icon: <RotateCcw className="w-8 h-8 text-white" />,
            bgColor: "from-orange-500 to-orange-600",
            iconBg: "bg-orange-500"
        },
        {
            id: 7,
            title: "Chargeback Management",
            // description: "Process partial and full refunds instantly with complete audit trails for transparent transaction management.",
            description: " Integrated dispute resolution & case tracking.",
            icon: <RotateCcw className="w-8 h-8 text-white" />,
            bgColor: "from-orange-500 to-orange-600",
            iconBg: "bg-orange-500"
        }
    ];





    const PanelCard = ({ title, subtitle, features, bgGradient }) => (
        <div className={`rounded-xl ${bgGradient} p-8 text-white shadow-xl transform hover:scale-105 transition-all duration-300`}>
            <div className="mb-6">
                <h2 className="text-3xl font-bold mb-2">{title}</h2>
                <p className="text-lg opacity-90">{subtitle}</p>
            </div>

            <div className="space-y-4">
                {features.map((feature, index) => {
                    const IconComponent = feature.icon;
                    return (
                        <div key={index} className="flex items-start space-x-3 bg-white/10 rounded-lg p-3 backdrop-blur-sm">
                            <IconComponent className="w-6 h-6 mt-1 flex-shrink-0" />
                            <span className="text-base leading-relaxed">{feature.text}</span>
                        </div>
                    );
                })}
            </div>
        </div>
    );

    return (
        <div className="min-h-screen bg-white">
            {/* Hero Section - Keep unchanged as requested */}
            <Header />

            <section
                className="relative pt-12 pb-12 px-4 sm:px-6 lg:px-8 min-h-[70vh] flex items-center overflow-hidden"
                style={{
                    background: `linear-gradient(135deg, 
          rgba(59, 130, 246, 0.1) 0%, 
          rgba(147, 51, 234, 0.1) 50%, 
          rgba(219, 39, 119, 0.1) 100%
        )`,
                    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
                }}
            >
                {/* Animated Background Elements */}
                <div className="absolute inset-0 overflow-hidden pointer-events-none">
                    <div
                        className="absolute top-20 left-10 w-32 h-32 bg-gradient-to-br from-blue-200/30 to-purple-200/30 rounded-full animate-pulse transform rotate-45"
                        style={{ transform: `translateY(${scrollY * 0.1}px) rotate(45deg)` }}
                    ></div>
                    <div
                        className="absolute top-40 right-20 w-24 h-24 bg-gradient-to-br from-indigo-200/40 to-blue-200/40 rounded-lg animate-bounce transform rotate-12"
                        style={{ animationDelay: '1s', transform: `translateY(${scrollY * 0.15}px) rotate(12deg)` }}
                    ></div>
                    <div
                        className="absolute bottom-20 left-20 w-16 h-16 bg-gradient-to-br from-purple-200/30 to-pink-200/30 rounded-full animate-pulse transform -rotate-12"
                        style={{ animationDelay: '2s', transform: `translateY(${scrollY * 0.2}px) rotate(-12deg)` }}
                    ></div>
                    <div
                        className="absolute bottom-40 right-10 w-20 h-20 bg-gradient-to-br from-cyan-200/40 to-blue-200/40 rounded-lg animate-bounce transform rotate-45"
                        style={{ animationDelay: '0.5s', transform: `translateY(${scrollY * 0.12}px) rotate(45deg)` }}
                    ></div>
                </div>

                <div className="max-w-7xl mx-auto">
                    <div className="grid lg:grid-cols-2 gap-8 items-center">
                        {/* Left Content */}
                        <div className="space-y-6">
                            <div className="space-y-4">
                                {/* <div className="flex justify-start">
                  <div className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-500 to-purple-500 text-white px-4 py-2 rounded-full text-sm font-medium shadow-lg">
                    <Star className="w-4 h-4" />
                    <div className="text-center leading-tight">
                      Reconciliation with AI</div>
                  </div>
                </div> */}

                                <div className="flex justify-start">
                                    <div className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-500 to-purple-500 text-white px-4 py-1.5 rounded-full text-xs sm:text-sm font-medium shadow-md max-w-full">
                                        <Star className="w-3 h-3 flex-shrink-0" aria-hidden="true" />
                                        <p className="whitespace-normal leading-tight">
                                            Real-Time UPI Transactions — Fast, Scalable, & NPCI-Compliant.                                         </p>
                                    </div>
                                </div>

                                {/* <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight tracking-tight">
                  <div className="text-slate-800 font-bold mb-2">
                    From Complexity to Clarity
                  </div>
                  <div className="bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text text-transparent font-semibold leading-snug">
                    Automating Reconciliation Across Industries
                  </div>
                </h1> */}

                                <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight tracking-tight">
                                    <div className="text-gray-800 font-semibold">
                                        UPI SWITCH PLATFORM
                                    </div>
                                    <div className="text-lg sm:text-xl lg:text-1.5xl font-medium bg-gradient-to-r from-blue-600 via-purple-600 to-indigo-600 bg-clip-text text-transparent mt-1">
                                        The Core Engine Powering Seamless UPI Transactions                                    </div>
                                </h1>

                                <p className="text-base text-slate-600 leading-relaxed font-normal">
                                    UPI is India’s most powerful real-time payments ecosystem. Our UPI Switch is a next-generation platform that enables banks, PSPs, and fintechs to handle millions of UPI transactions with speed, security, and intelligence.
                                    Built to be NPCI-compliant, scalable, and API-driven, it supports Pay, Collect, Mandates, P2P, P2M, IPO, BBPS, and future UPI 2.0/3.0 use cases — all from a single, robust platform.                                    </p>

                                {/* Key Features */}
                                {/* <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-4">
                                    <div className="flex items-center gap-2">
                                        <Cpu className="w-5 h-5 text-green-600" />
                                        <span className="text-sm text-slate-700 font-medium">Automated Matching</span>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <Search className="w-5 h-5 text-blue-600" />
                                        <span className="text-sm text-slate-700 font-medium">Anomaly Detection</span>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <BarChart className="w-5 h-5 text-purple-600" />
                                        <span className="text-sm text-slate-700 font-medium">Real-Time Insights</span>
                                    </div>
                                </div> */}

                            </div>
                        </div>

                        {/* Right Content - Video Placeholder */}
                        <div className="relative">
                            <div className="relative rounded-xl overflow-hidden shadow-2xl bg-black/20 backdrop-blur-sm border border-white/10">
                                <video
                                    className="w-full h-auto rounded-xl"
                                    autoPlay
                                    muted
                                    loop
                                    playsInline
                                    src="./UPISwitchVideo.mp4"
                                    preload="metadata"
                                >
                                    <source src="/path/to/your/video.mp4" type="video/mp4" />
                                    <source src="/path/to/your/video.webm" type="video/webm" />
                                    Your browser does not support the video tag.
                                </video>

                                {/* Optional overlay for styling */}
                                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none rounded-xl"></div>
                            </div>

                            {/* Decorative elements */}
                            <div className="absolute -top-4 -right-4 w-20 h-20 bg-purple-400/30 rounded-full blur-xl"></div>
                            <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-blue-400/30 rounded-full blur-lg"></div>
                        </div>
                    </div>
                </div>
            </section>


            <section className="py-12 bg-slate-50 px-4 sm:px-6 lg:px-8" >
                <div className="max-w-6xl mx-auto">
                    <div className="text-center mb-4">
                        <h2 className="block bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text text-transparent text-2xl sm:text-3xl lg:text-4xl font-bold mb-3 animate-pulse hover:animate-none transition-all duration-500 hover:scale-105 cursor-default">
                            {/* Complete Payment Gateway */}
                            CORE FEATURES OF UPI SWITCH
                        </h2>

                    </div>
                    {/* Image Container */}
                    <div className="relative group w-full">
                        <div className="relative bg-white rounded-xl overflow-hidden transition-all duration-300">
                            <img
                                src="/switch.png" // Replace with your image path
                                alt="Payment Gateway Platform Screenshot"
                                className={`w-full h-auto max-h-100 object-cover transition-all duration-300 ${imageLoaded ? 'opacity-100' : 'opacity-0'
                                    }`}
                                onLoad={() => setImageLoaded(true)}
                            />
                        </div>
                        {/* Decorative Elements */}
                        <div className="absolute -top-3 -right-3 w-16 h-16 bg-gradient-to-br from-slate-400/15 to-slate-500/15 rounded-full blur-lg"></div>
                        <div className="absolute -bottom-4 -left-4 w-20 h-20 bg-gradient-to-br from-slate-500/15 to-slate-600/15 rounded-full blur-lg"></div>
                    </div>
                </div>
            </section>


            <div className="py-16 px-4 bg-slate-50">
                <div className="max-w-6xl mx-auto text-center">
                    <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 animate-fade-in-up">
                        <span className="inline-block animate-pulse bg-gradient-to-r from-blue-600 via-purple-600 to-cyan-600 bg-clip-text text-transparent">
                            ADVANCED CAPABILITIES
                        </span>{" "}
                        {/* <span className="inline-block animate-bounce-slow">

                            Payment Gateway Suite?
                        </span> */}
                    </h2>

                    <style jsx>{`
                    @keyframes fade-in-up {
                        0% {
                            opacity: 0;
                            transform: translateY(20px);
                        }
                        100% {
                            opacity: 1;
                            transform: translateY(0);
                        }
                    }

                    @keyframes bounce-slow {
                        0%, 20%, 50%, 80%, 100% {
                            transform: translateY(0);
                        }
                        40% {
                            transform: translateY(-3px);
                        }
                        60% {
                            transform: translateY(-1px);
                        }
                    }

                    .animate-fade-in-up {
                        animation: fade-in-up 1s ease-out;
                    }

                    .animate-bounce-slow {
                        animation: bounce-slow 2s infinite;
                        animation-delay: 0.5s;
                    }
                `}</style>

                    <div className="grid md:grid-cols-3 gap-6 mt-12">
                        {features.map((feature, index) => (
                            <div
                                key={index}
                                className="p-6 bg-white border border-gray-200 rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 flex flex-col items-center text-center group hover:scale-[1.02] transition-transform"
                            >
                                <div className={`mb-4 p-4 rounded-full bg-${feature.color}-100 text-${feature.color}-600`}>
                                    {feature.icon}
                                </div>
                                <h3 className="text-base font-semibold text-slate-800 mb-2">{feature.title}</h3>
                                <p className="text-sm text-slate-600 leading-relaxed">{feature.desc}</p>
                            </div>
                        ))}
                    </div>

                </div>
            </div>
            <section className="py-8 bg-gradient-to-br from-blue-600 via-indigo-600 to-purple-700 relative overflow-hidden">
                <div className="absolute inset-0 overflow-hidden pointer-events-none">
                    <div className="absolute top-10 left-10 w-32 h-32 bg-white/10 rounded-full animate-pulse"></div>
                    <div className="absolute top-40 right-20 w-24 h-24 bg-white/5 rounded-lg animate-bounce transform rotate-45" style={{ animationDelay: '1s' }}></div>
                    <div className="absolute bottom-20 left-20 w-16 h-16 bg-white/10 rounded-full animate-pulse" style={{ animationDelay: '2s' }}></div>
                    <div className="absolute bottom-40 right-10 w-20 h-20 bg-white/5 rounded-lg animate-bounce transform -rotate-12" style={{ animationDelay: '0.5s' }}></div>

                    <div className="absolute top-1/4 left-1/4 animate-float">
                        <Zap className="w-8 h-8 text-white/20" />
                    </div>
                    <div className="absolute top-1/3 right-1/3 animate-float" style={{ animationDelay: '1.5s' }}>
                        <Shield className="w-6 h-6 text-white/20" />
                    </div>
                    <div className="absolute bottom-1/3 left-1/3 animate-float" style={{ animationDelay: '3s' }}>
                        <TrendingUp className="w-7 h-7 text-white/20" />
                    </div>
                </div>

                <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
                    {/* Main Content */}
                    <div className="space-y-4 animate-fadeInUp">
                        <h2 className="text-2xl sm:text-3xl lg:text-3xl font-bold text-white leading-tight animate-slideInLeft">
                            Empowering Banks and Merchants with Real-Time Switching and Smart Routing for Maximum Success and Efficiency.
                        </h2>
                    </div>

                    {/* CTA Button - Smaller and More Compact */}
                    <div className="mt-6 animate-fadeInUp" style={{ animationDelay: '1.2s' }}>
                        <button
                            className="group relative inline-flex items-center gap-3 bg-gradient-to-r from-white to-blue-50 text-blue-700 px-8 py-3 rounded-xl font-semibold text-lg hover:from-yellow-300 hover:to-orange-300 hover:text-gray-900 transform hover:scale-105 transition-all duration-500 shadow-xl hover:shadow-yellow-300/50"
                            onClick={() => {
                                window.location.href = '/contact';
                            }}
                        >
                            <Play className="w-5 h-5 group-hover:animate-bounce" />
                            <span>Get In Touch</span>
                            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />

                            {/* Button Glow Effect */}
                            <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                        </button>
                    </div>
                </div>

                <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          33% { transform: translateY(-10px) rotate(5deg); }
          66% { transform: translateY(5px) rotate(-5deg); }
        }
        
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        @keyframes slideInLeft {
          from { opacity: 0; transform: translateX(-50px); }
          to { opacity: 1; transform: translateX(0); }
        }
        
        @keyframes slideInRight {
          from { opacity: 0; transform: translateX(50px); }
          to { opacity: 1; transform: translateX(0); }
        }
        
        @keyframes slideInUp {
          from { opacity: 0; transform: translateY(40px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        .animate-float {
          animation: float 4s ease-in-out infinite;
        }
        
        .animate-fadeInUp {
          animation: fadeInUp 0.8s ease-out forwards;
          opacity: 0;
        }
        
        .animate-slideInLeft {
          animation: slideInLeft 0.8s ease-out forwards;
          opacity: 0;
        }
        
        .animate-slideInRight {
          animation: slideInRight 0.8s ease-out forwards;
          opacity: 0;
        }
        
        .animate-slideInUp {
          animation: slideInUp 0.8s ease-out forwards;
          opacity: 0;
        }
      `}</style>
            </section>
            <Footer />
        </div>
    );
}

